import { Box } from "@mui/joy";
import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";

import { ProjectProvider, TaskProvider } from "../provider";
import { AnimationWrapper, Header, AppNavigation } from "../components";

export default function PostAuthentication() {
    const [collapsed, setCollapsed] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // We still need to know if we are on mobile to change the Header toggle behavior
    const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 600);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <Box sx={{ height: "100dvh", display: "flex", overflow: "hidden", position: "relative" }}>
            <AppNavigation
                collapsed={collapsed}
                setCollapsed={setCollapsed}
                isMenuOpen={isMenuOpen}
                setIsMenuOpen={setIsMenuOpen}
            />

            <Box sx={{ flex: 1, display: "flex", flexDirection: "column", maxHeight: "100dvh", minWidth: 0 }}>
                <Header
                    onToggleCollapse={isMobile ? () => setIsMenuOpen(true) : () => setCollapsed(!collapsed)}
                    isCollapsed={collapsed}
                />
                <Box
                    sx={{
                        flex: 1,
                        overflow: "auto",
                        minHeight: 0,
                        minWidth: 0,
                        display: "flex",
                        position: "relative",
                        pb: isMobile ? "64px" : 0,
                    }}
                >
                    <ProjectProvider>
                        <TaskProvider>
                            <AnimationWrapper>
                                <Outlet />
                            </AnimationWrapper>
                        </TaskProvider>
                    </ProjectProvider>
                </Box>
            </Box>
        </Box>
    );
}
